import * as Sentry from '@sentry/react';
import environment from '@/environment';
import { AuthResult } from '@/schemas/clientInitSchema';
import { datadogRum } from '@datadog/browser-rum';
import sessionId from './session-service';

interface ReportError {
  error: unknown;
  // Optional scalar context attached to the Sentry event (e.g. a Braintree
  // error's nested originalError fields). Keep to primitives — do not pass whole
  // error objects (circular refs).
  context?: Record<string, unknown>;
}
interface ReportMessage {
  message: string;
}

export function trackUser({ quote_id, partner }: AuthResult) {
  const id = sessionId();

  Sentry.setUser({
    id: id,
    quoteId: quote_id,
  });

  Sentry.setExtra('partner', partner);

  datadogRum.setUser({
    id: id,
    quoteId: quote_id,
    partner: partner,
  });
}

export function reportError({ error, context }: ReportError) {
  if (environment.environment !== 'production') {
    console.error(error, context);
  }

  Sentry.withScope((scope) => {
    scope.setTag('team', 'onboarding_team');

    if (context) {
      scope.setContext('errorContext', context);
    }

    Sentry.captureException(error);
  });

  // Also forward to Datadog RUM so the error is visible on the session replay
  // timeline. `experience` and user attributes are already attached to every
  // RUM event globally (see datadog-service#updateSessionContext), so we do not
  // pass them here — only the caller-supplied context (e.g. an error_signature).
  datadogRum.addError(error, context);
}

export function reportMessage({ message }: ReportMessage) {
  if (environment.environment !== 'production') {
    console.error(message);
  }

  Sentry.withScope((scope) => {
    scope.setTag('team', 'onboarding_team');

    Sentry.captureMessage(message);
  });
}
